<template>
    <div class="frontBackaAppraisal_tea">
        <div class="filtrate">
            <el-select v-model="termValue" placeholder="请选择" @change="termChange">
                <el-option v-for="(item, index) in termList" :key="index" :label="item.termName" :value="item.key">
                </el-option>
            </el-select>
            <el-select v-model="reportValue" placeholder="请选择" @change="reportChange">
                <el-option v-for="item in reportList" :key="item.type" :label="item.name" :value="item.type">
                </el-option>
            </el-select>
            <el-select v-model="monthVal" placeholder="请选择" @change="monthTypeChange" v-if="reportValue == 4">
                <el-option v-for="item in monthList" :key="item.value" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="weekValue" placeholder="请选择" @change="weekValTypeChange" v-if="reportValue == 5">
                <el-option v-for="(item, index) in weekList" :key="index" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="gradeValue" placeholder="请选择" @change="gradeChange" :disabled="isGradeSelectDisabled">
                <el-option v-for="item in gradeList" :key="item.value" :label="item.name"
                    :value="{ label: item.name, value: item.bindId }">
                </el-option>
            </el-select>
            <div class="export flex-align">
                <div class="wrap flex-align" @click="table_type == 2 ? getexportExcel_week() : getexportExcel()">
                    <img src="../../assets/newReport/export.png" alt="">
                    导出数据
                </div>
            </div>
        </div>
        <div class="type_title flex-column-center">
            <!-- <h1>{{ schoolName }}{{ gradeValue }}{{ reportValue == 1 ? '前测' : reportValue == 2 ? '后测' : reportValue == 4
                ? '月测' : '周测' }}报告</h1> -->
            <h1>{{ reportTitle }}</h1>
            <h2
                v-if='reportValue == 1 || reportValue == 2 || reportValue == 101 || reportValue == 102 || reportValue == 103'>
                {{ semester_name }}</h2>
            <h2 v-if="reportValue == 4">{{ monthName }}</h2>
            <h2 v-if="reportValue == 5">{{ weekName }}</h2>
        </div>
        <!-- 前后测报告 -->
        <div class="overall_situation" v-if='reportValue != 4 && reportValue != 5'>
            <template v-if="!isEmpty">
                <div class="empty">
                    <el-empty description="暂无报告"></el-empty>
                </div>
            </template>
            <template v-else>
                <h1 class="First_level_heading">1.整体情况</h1>
                <div class="participation">
                    <div class="broad_heading flex-align-around">
                        <div class="Participate_assessment nature">
                            <div class="broad_title">本次测评参与</div>
                            <div class="broad_tcount">
                                <span>{{ userNum }}</span><span>人</span>
                            </div>
                            <div class="proportion">本年级参与率{{ gradeRate }}%</div>
                        </div>
                        <div class="hold_posture nature">
                            <div class="broad_title">握姿错误</div>
                            <div class="broad_tcount">
                                <span>{{ wrongGrip }}</span><span>人</span>
                            </div>
                            <div class="proportion">本年级{{ gradeWrongGrip }}人</div>
                        </div>
                        <div class="sit_posture nature">
                            <div class="broad_title">坐姿错误</div>
                            <div class="broad_tcount">
                                <span>{{ wrongSitPosition }}</span><span>人</span>
                            </div>
                            <div class="proportion">本年级{{ gradeWrongSitPosition }}人</div>
                        </div>
                        <div class="excellent_rate nature">
                            <div class="broad_title">{{ table_type == 1 ? '优秀率' : '优良率' }}</div>
                            <div class="broad_tcount">
                                <span>{{ excellentRate }}</span><span>%</span>
                            </div>
                            <div class="proportion">本年级{{ gradeExcellentRate }}%</div>
                        </div>
                    </div>
                    <div class="writing_habit_sitting">
                        <!-- //标题 -->
                        <div class="Secondary_heading">
                            <div class="vertical_grain_icon"></div> <span class="title">书写习惯-坐姿</span>
                        </div>
                        <div class="substance">
                            <div class="substance_details flex-between">
                                <div class="sitting_position_table">
                                    <img src="../../assets/newReport/sitting.png" alt="">
                                    <Short_form_tea :construction="sitting_construction" :tabledata="sitting_Data"
                                        :high="Height1" :row_high="row_height1" :version="table_type"></Short_form_tea>
                                </div>
                                <div class="sitting_position_graph" id="sitting_position_graph"></div>
                            </div>
                            <div class="sitting_conclusion conclusion">
                                <span class="prefix_title">结论1</span>
                                针对坐姿，有<span class="Comment_highlight">{{ sitting_Data_mistake }}</span>名学生出现坐姿错误，占全校的<span
                                    class="Comment_highlight">{{ sitting_wrongNumSchoolRatio }}%</span>。
                            </div>
                        </div>
                    </div>
                    <div class="writing_habit_sitting">
                        <!-- //标题 -->
                        <div class="Secondary_heading">
                            <div class="vertical_grain_icon"></div> <span class="title">书写习惯-握笔姿势</span>
                        </div>
                        <div class="substance">
                            <div class="substance_details flex-between">
                                <div class="sitting_position_table">
                                    <img src="../../assets/newReport/hold.png" alt="">
                                    <Short_form_tea :construction="hold_construction" :tabledata="hold_Data" :high="Height1"
                                        :row_high="row_height1" :version="table_type"></Short_form_tea>
                                </div>
                                <div class="sitting_position_graph" id="hold_position_graph"></div>
                            </div>
                            <div class="sitting_conclusion conclusion">
                                <span class="prefix_title">结论2</span>
                                针对握笔姿势，有<span class="Comment_highlight">{{ hold_Data_mistake
                                }}</span>名学生使用了错误的握笔姿势，占全校的<span class="Comment_highlight">{{ hold_wrongNumSchoolRatio
}}%</span>。
                            </div>
                        </div>
                    </div>
                    <div class="writing_habit_sitting">
                        <div class="Secondary_heading">
                            <div class="vertical_grain_icon"></div> <span class="title">书写结果判断握笔姿势</span>
                        </div>
                        <div class="result_judgment">
                            <img :src="sitimg ? require('../../assets/newReport/wobi2.png') : require('../../assets/newReport/wobi1.png')"
                                alt="">
                            <div class="result_judgment_btn flex-align-center" @click="sitimg = !sitimg">换一组查看</div>
                        </div>
                    </div>
                    <score_Proportion_tea_old ref="score_Proportion_tea_old" v-if="table_type == 1" :old_data="old_data">
                    </score_Proportion_tea_old>
                    <score_Proportion_tea_new ref="score_Proportion_tea_new" :new_data="new_data" v-else>
                    </score_Proportion_tea_new>
                    <div class="writing_habit_sitting" v-if="workList.length != 0">
                        <div class="outstanding_example">
                            <div class="outstanding_tit flex-align-center">
                                <img src="../../assets/newReport/specimen.png" alt="" v-if="table_type == 1" />
                                <img src="../../assets/newReport/specimen2.png" alt="" v-else />
                            </div>
                            <div class="works flex-align-center">
                                <div class="el_image_box flex-align-center">
                                    <el-image :src="item" v-for="(item, index) in workList" :key="index"
                                        :preview-src-list="workList">
                                    </el-image>
                                </div>
                            </div>
                            <div class="changeset flex-align-center ">
                                <div class="changeset_btn flex-align-center">换一组查看</div>
                            </div>
                        </div>
                    </div>
                    <div class="writing_habit_sitting writing_habit_sitting-between">
                        <div class="writing_habit_sitting_separate">
                            <div class="Secondary_heading">
                                <div class="vertical_grain_icon"></div> <span class="title">本班{{ table_type ==
                                    1 ? '优秀' : '优良' }}学生名单</span>
                            </div>
                            <div class="student_list_box">
                                <div class="student_list">
                                    <!-- <Short_form_tea :construction="student_list_construction" :tabledata="student_list_Data"
                                        :high="Height2" :row_high="row_height2"></Short_form_tea> -->
                                    <Short_form_tea_JumpAttribute :construction="student_list_construction" :high="Height2"
                                        :row_high="row_height2" :tabledata="student_list_Data" :termValue="termValue"
                                        :currentTerm="currentTerm" :reportValue="reportValue" monthVal=""
                                        :term_type="term_type" Mark="0">
                                    </Short_form_tea_JumpAttribute>
                                </div>
                            </div>
                        </div>
                        <div class="writing_habit_sitting_separate">
                            <div class="Secondary_heading">
                                <div class="vertical_grain_icon"></div>
                                <span class="title">进步较大的学生</span>
                            </div>
                            <div class="student_list_box">
                                <div class="student_list flex-align-center" v-if="profilePictureData.length > 0">
                                    <ul class="progress">
                                        <li class="flex-align" v-for="(item, index) in profilePictureData" :key="index">
                                            <div class="top_img">
                                                <img src="../../assets/newReport/first.png" alt="" v-if="index == 0">
                                                <img src="../../assets/newReport/second.png" alt="" v-if="index == 1">
                                                <img src="../../assets/newReport/third.png" alt="" v-if="index == 2">
                                            </div>
                                            <div class="profilePicture">
                                                <img src="../../assets/datascreen/boy.png" alt=""
                                                    @click="showImagePreview(`image${index}`)">
                                            </div>
                                            <div>
                                                <span @click="showImagePreview(`image${index}`)">{{ item.userName }}</span>
                                            </div>
                                            <el-image :src="imageSrc" :preview-src-list="item.imgUrls"
                                                :ref="`image${index}`" v-show="false"></el-image>


                                        </li>
                                    </ul>
                                </div>
                                <div class="student_list  student_list_seat  flex-align-center" v-else>
                                    <span>暂无数据</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <h1 class="First_level_heading">2.班级历史成绩对比</h1>
                <div class="participation flex-align-between" style="padding-top: 50px;">
                    <div class="fourQuadrantsItem" v-for="(item, index) in fourQuadrantsStuList" :key="index"
                        @click="selectItem(item, index)">
                        <fourQuadrants :id_type="index" :chartData="item" :gradeId="currentGrade"></fourQuadrants>
                    </div>
                    <div class="conclusion-box flex-column">
                        <span class="prefix_title">总结与建议</span>
                        <span>
                            1.优秀表现与持续进步。在居中占位(从50分提升到76分)占格大小(61分到81分)和多画等距(56分到74分)上进步显著，书写更工整、大小更均匀，说明练习方法有效！建议继续用田字格强化布局，多练“三”“中”等字巩固成果，
                            此外，组合关系(73分到75分)长期稳定，能熟练搭配字的部件，可尝试挑战“赢”“器”等复杂字进一步提升水平。
                        </span>
                        <span>
                            2.重点提升方向与家庭支持。字形重心(最低61分)和笔画关系(仅59分)仍需加强，部分字可能歪斜或笔画衔接不够自然。建议练习时用虚线标出重心线，多写“正"“国"等对称字；拆分练习“横折钩“等笔画组合，观察字帖细节，
                            家长可每天陪练20分钟，用红笔圈出优秀字鼓励孩子，标记问题字针对性纠正，整体来看孩子书写习惯进步明显(44分到64分)，但细节需长期打。坚持练习，一定能更上一层楼！
                        </span>
                    </div>
                </div>
            </template>
        </div>
        <!-- 月测报告 -->
        <div class="overall_situation" v-if="reportValue == 4">
            <template v-if="!isEmpty">
                <div class="empty">
                    <el-empty description="暂无报告"></el-empty>
                </div>
            </template>
            <template v-else>
                <h1 class="First_level_heading">1.整体情况</h1>
                <div class="participation">
                    <div class="broad_heading flex-align-around">
                        <div class="Participate_assessment nature">
                            <div class="broad_title">本次测评参与</div>
                            <div class="broad_tcount">
                                <span>{{ userNum }}</span><span>人</span>
                            </div>
                            <div class="proportion">本年级参与率{{ gradeRate }}%</div>
                        </div>
                        <div class="hold_posture nature">
                            <div class="broad_title">{{ table_type == 1 ? '优秀+' : '优秀' }}</div>
                            <div class="broad_tcount">
                                <span>{{ wrongGrip }}</span><span>人</span>
                            </div>
                            <div class="proportion">占本年级的{{ gradeWrongGrip }}%</div>
                        </div>
                        <div class="sit_posture nature">
                            <div class="broad_title">待提升</div>
                            <div class="broad_tcount">
                                <span>{{ wrongSitPosition }}</span><span>人</span>
                            </div>
                            <div class="proportion">本年级{{ gradeWrongSitPosition }}人</div>
                        </div>
                        <div class="excellent_rate nature">
                            <div class="broad_title">{{ table_type == 1 ? '优秀率' : '优良率' }}</div>
                            <div class="broad_tcount">
                                <span>{{ excellentRate }}</span><span>%</span>
                            </div>
                            <div class="proportion">本年级{{ gradeExcellentRate }}%</div>
                        </div>
                    </div>
                    <div class="writing_habit_sitting">
                        <!-- //标题 -->
                        <div class="flex-between">
                            <div>
                                <div class="Secondary_heading">
                                    <div class="vertical_grain_icon"></div> <span class="title">本班单项成绩等级占比</span>
                                </div>
                                <div class="substance">
                                    <div class="substance_details flex-between">
                                        <!-- :high="Height1" :row_high="row_height3" -->
                                        <div class="sitting_position_table">
                                            <Short_form_tea :construction="month_construction" :tabledata="month_Data"
                                                type="月测"></Short_form_tea>
                                            <div class="sitting_position_graph" id="month_class_proportion"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="Secondary_heading">
                                    <div class="vertical_grain_icon"></div> <span class="title">本班学生测评等级列表</span>
                                </div>
                                <div class="student_list_box2">
                                    <div class="student_list2">
                                        <Short_form_tea_JumpAttribute :construction="monthstudent_list_construction"
                                            :high="HeightList" :row_high="HeightList_row"
                                            :tabledata="month_student_list_Data" :termValue="termValue"
                                            :currentTerm="currentTerm" :reportValue="reportValue" :monthVal="monthVal"
                                            :term_type="term_type" Mark="1">
                                        </Short_form_tea_JumpAttribute>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sitting_conclusion conclusion">
                            <span class="prefix_title">结论1</span>
                            本班学生综合成绩来看,平均成绩<span class="Comment_highlight">{{ maxClassLevel }}</span>等级的学生居多,
                            {{ table_type == 1 ? '优秀率' : '优良率' }}为<span class="Comment_highlight">{{ maxClassProp }}%</span>
                            <span v-if="maxgradeProp != 0 && maxgradeProp != 0">，
                                <span class="Comment_highlight">{{ gradeCompare }}</span>年级{{ table_type == 1 ? '优秀率' :
                                    '优良率' }}。
                            </span>
                            <span v-else>。</span>
                        </div>
                    </div>
                    <singleSubjectAvg_tea_month_old ref="singleSubjectAvg_tea_month_old" v-if="table_type == 1">
                    </singleSubjectAvg_tea_month_old>
                    <singleSubjectAvg_tea_month_new ref="singleSubjectAvg_tea_month_new" :userNum="userNum"
                        :gradeValue="gradeValue" type="月测" v-else>
                    </singleSubjectAvg_tea_month_new>
                    <div class="writing_habit_sitting" v-if="workList.length != 0">
                        <div class="outstanding_example">
                            <div class="outstanding_tit flex-align-center">
                                <img src="../../assets/newReport/specimen.png" alt="" v-if="table_type == 1" />
                                <img src="../../assets/newReport/specimen2.png" alt="" v-else />
                            </div>
                            <div class="works flex-align-center">
                                <div class="el_image_box flex-align-center">
                                    <el-image :src="workurl"></el-image>
                                </div>
                            </div>
                            <div class="changeset flex-align-center ">
                                <div class="changeset_btn flex-align-center" @click="stochastic">换一组查看</div>
                            </div>
                        </div>
                    </div>
                </div>
                <h1 class="First_level_heading">2.班级历史成绩对比</h1>
                <div class="participation flex-align-between" style="padding-top: 50px;">
                    <div class="fourQuadrantsItem" v-for="(item, index) in fourQuadrantsStuList" :key="index"
                        @click="selectItem(item, index)">
                        <fourQuadrants :id_type="index" :chartData="item" :gradeId="currentGrade"></fourQuadrants>
                    </div>
                    <div class="conclusion-box flex-column">
                        <span class="prefix_title">总结与建议</span>
                        <span>
                            1.优秀表现与持续进步。在居中占位(从50分提升到76分)占格大小(61分到81分)和多画等距(56分到74分)上进步显著，书写更工整、大小更均匀，说明练习方法有效！建议继续用田字格强化布局，多练“三”“中”等字巩固成果，
                            此外，组合关系(73分到75分)长期稳定，能熟练搭配字的部件，可尝试挑战“赢”“器”等复杂字进一步提升水平。
                        </span>
                        <span>
                            2.重点提升方向与家庭支持。字形重心(最低61分)和笔画关系(仅59分)仍需加强，部分字可能歪斜或笔画衔接不够自然。建议练习时用虚线标出重心线，多写“正"“国"等对称字；拆分练习“横折钩“等笔画组合，观察字帖细节，
                            家长可每天陪练20分钟，用红笔圈出优秀字鼓励孩子，标记问题字针对性纠正，整体来看孩子书写习惯进步明显(44分到64分)，但细节需长期打。坚持练习，一定能更上一层楼！
                        </span>
                    </div>
                </div>
            </template>
        </div>
        <!-- <weekTest_tea :termValue="termValue" :weekValue="weekValue" :weekName="weekName" :gradeId="gradeId"
            :gradeValue="gradeValue" :isEmpty="!isEmpty" ref="weekTest_tea" v-else></weekTest_tea> -->
        <weekTest_tea ref="weekTest_tea" :fourQuadrantsStuList="fourQuadrantsStuList" :currentGrade="currentGrade" v-if="reportValue == 5">
        </weekTest_tea>
        <!-- 四象限弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" center>
            <div id="historyChart" class="historyChart"></div>
        </el-dialog>
    </div>
</template>
<script>
import Short_form_tea from './appraisalCharts/Short_form_tea.vue'
import Short_form_tea_JumpAttribute from './appraisalCharts/Short_form_tea_JumpAttribute.vue'
import score_Proportion_tea_old from './score_Proportion_tea_old.vue'
import score_Proportion_tea_new from './score_Proportion_tea_new.vue'
import singleSubjectAvg_tea_month_old from './singleSubjectAvg_tea_month_old.vue'
import singleSubjectAvg_tea_month_new from './singleSubjectAvg_tea_month_new.vue'
import weekTest_tea from './weekTest_tea.vue'
import fourQuadrants from './fourQuadrants.vue'

export default {
    //import引入组件才能使用
    components: {
        Short_form_tea,
        Short_form_tea_JumpAttribute,
        score_Proportion_tea_old,
        score_Proportion_tea_new,
        singleSubjectAvg_tea_month_old,
        singleSubjectAvg_tea_month_new,
        weekTest_tea,
        fourQuadrants
    },
    props: {},
    data() {
        return {
            schoolName: '',
            semester_name: '',
            //顶部筛选-学期/报告类型
            reportList: [
                // {
                //     value: 101,
                //     label: '测评卷Ⅰ'
                // },
                // {
                //     value: 102,
                //     label: '测评卷Ⅱ'
                // },
                // {
                //     value: 103,
                //     label: '测评卷Ⅲ'
                // },
                // {
                //     value: 1,
                //     label: '前测报告'
                // },
                // {
                //     value: 2,
                //     label: '后测报告'
                // },
                // {
                //     value: 4,
                //     label: '月测报告'
                // },
                // {
                //     value: 5,
                //     label: '周测报告'
                // }
            ],
            reportValue: '',
            //书写习惯-坐姿
            sitting_construction: [{
                fieldName: 'date',
                title: '学期'
            },
            {
                fieldName: 'wrongNum',
                title: '错误坐姿人数'
            },
            {
                fieldName: 'ratio',
                title: '坐姿错误比例'
            },
            ],
            sitting_Data: [],
            // 坐姿错误人数
            sitting_Data_mistake: 0,
            // 占全校
            sitting_wrongNumSchoolRatio: 0,
            //书写习惯-握笔
            hold_construction: [{
                fieldName: 'date',
                title: '学期'
            },
            {
                fieldName: 'wrongNum',
                title: '握笔错误人数'
            },
            {
                fieldName: 'ratio',
                title: '握笔错误比例'
            },
            ],
            hold_Data: [],
            // 坐姿错误人数
            hold_Data_mistake: 0,
            // 占全校
            hold_wrongNumSchoolRatio: 0,
            // Height1: '212px',
            Height1: '136.5px',
            HeightList: '635.7px',
            HeightList_row: '42.38px',
            // row_height1: '70px',
            row_height1: '45px',
            sitimg: true,
            //握笔错误人数
            // 标题
            hold_ratio_Data: [],
            // 结论
            // 章法占格
            layout: '',
            // 结构组合
            structure: '',
            // 笔画形态
            form: '',
            k1: '',
            k2: '',
            k3: '',
            // 作品完整度
            complete: '',
            Term_comparison_Data: [],
            dimension_Data: [],
            dimension_Data_layout1: '',
            dimension_Data_layout2: '',
            dimension_Data_structure1: '',
            dimension_Data_structure2: '',
            dimension_Data_form1: '',
            dimension_Data_form2: '',
            dimension_Data_complete1: '',
            dimension_Data_complete2: '',
            //箭头类型
            imgUrl: {
                imgUrl1: require('@/assets/newReport/greent.png'),
                imgUrl2: require('@/assets/newReport/redx.png'),
                imgUrl3: require('@/assets/newReport/or_r.png'),
            },
            student_list_construction: [
                {
                    fieldName: 'name',
                    title: '姓名'
                },
                {
                    fieldName: 'newlevel',
                    title: '整体等级'
                },
                // {
                //     fieldName: 'className',
                //     title: '年级'
                // },
                // {
                //     fieldName: 'gradeName',
                //     title: '班级'
                // },
            ],
            student_list_Data: [],
            Height2: '470px',
            // Height2: '',
            row_height2: '40px',
            row_height3: '20px',
            //学年
            termList: [],
            termValue: '',
            currentTerm: '',
            term_type: null,
            //班级
            gradeList: [],
            gradeValue: '',
            gradeId: '',
            //整体情况
            //测评人数
            userNum: 0,
            //本年级参与率
            gradeRate: 0,
            //握姿错误
            wrongGrip: 0,
            //本年级握姿错误
            gradeWrongGrip: 0,
            //坐姿错误
            wrongSitPosition: 0,
            //本年级坐姿错误
            gradeWrongSitPosition: 0,
            //优秀率
            excellentRate: 0,
            //本年级优秀率
            gradeExcellentRate: 0,
            limit: 2,
            pageSize: 1,
            workList: [require('../../assets/newReport/demo.jpg'), require('../../assets/newReport/demo.jpg')],
            reportType: 1, // 报告类型:4前测 5后测 6月测
            reportCode: 'LZ3-C-00', // 报告code:LZ3-C-00前测 LZ3-C-01后测
            monthVal: '',
            monthName: '',
            monthList: [],
            //周测
            weekValue: '',
            weekName: '',
            weekList: [],
            // 月测-本班单项成绩等级占比表
            month_construction: [{
                fieldName: 'integrationLevel',
                title: '等级'
            },
            {
                fieldName: 'classPropRate',
                title: '本班人数占比'
            },
            {
                fieldName: 'gradePropRate',
                title: '年级平均人数占比'
            }],
            month_Data: [],
            monthstudent_list_construction: [{
                fieldName: 'className',
                title: '班级'
            }, {
                fieldName: 'stuName',
                title: '姓名'
            },
            {
                fieldName: 'levelDesc',
                title: '等级'
            }],
            month_student_list_Data: [],
            gradeCompare: '',
            maxClassProp: 0,
            maxgradeProp: 0,
            maxClassLevel: '',
            AI_Data: [],
            dimension_Data2: [],
            workurl: '',
            isEmpty: false,
            table_type: null,
            new_data: null,
            old_data: null,
            schoolIdArr: ['181166', '1176', '181095', '181165', '1172', '181164', '1175', '181097', '1154'],
            imageSrc: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
            srcList: require('../../assets/newReport/demo.jpg'),
            isPreviewing: false,
            student_list_Data_level: {
                '4': '优秀',
                '3': '良好',
                '2': '合格',
                '1': '待提升',
            },
            student_list_Data_level_old: {
                '4': '优秀+',
                '3': '优秀',
                '2': '良好',
                '1': '待提升',
            },
            profilePictureData: [],
            className: '',
            fourQuadrantsStuList: [],
            currentGrade: null,
            dialogVisible: false,
            averageNum: {
                1: [78.6, 71.1],
                2: [64, 66.7],
                3: [61.6, 70.1],
                4: [62.4, 68.9],
                5: [61.5, 68.1],
                6: [60.4, 71]
            },
            dialogTitle: ''
        }
    },
    // 计算属性
    computed: {
        isGradeSelectDisabled() {
            return !this.gradeList.some(item => item.bindId == this.gradeId)
        },
        reportTitle() {
            const reportTypeMap = {
                1: '前测',
                2: '后测',
                101: '测评卷Ⅰ',
                102: '测评卷Ⅱ',
                103: '测评卷Ⅲ',
                4: '月测',
                5: '月测',
            };

            const reportType = this.reportValue ? reportTypeMap[this.reportValue] || reportTypeMap.default : '';
            return `${this.schoolName}${this.gradeValue}${reportType}报告`;
        }

    },
    // 方法集合
    methods: {
        //获取学年学期列表
        async getTermList() {
            let resData = await this.$Api.DataScreen.queryTermList();
            this.termList = resData.data;
            if (this.$route.query.fromType == 'multiRole' && this.$route.query.date) {
                this.termValue = Number(this.$route.query.date);
                const index = this.termList.findIndex(item => item.key == Number(this.$route.query.date));
                this.currentTerm = this.termList[index].termName;
                this.semester_name = this.termList[index].termName;
                this.term_type = this.termList[index].term;


            } else if (this.$route.query.source == 'upload') {
                this.termValue = Number(this.$route.query.termValue);
                this.currentTerm = this.termList.find(item => item.key == this.$route.query.termValue).termName;
                this.semester_name = this.termList.find(item => item.key == this.$route.query.termValue).termName;
                this.term_type = this.termList.find(item => item.key == this.$route.query.termValue).term;
                this.reportValue = Number(this.$route.query.reportValue);
                // this.weekValue = Number(this.$route.query.examId);
                // this.weekValue = '5年级周测4';
            } else {
                this.termValue = this.termList[0].key;
                this.currentTerm = this.termList[0].termName;
                this.semester_name = this.termList[0].termName;
                this.term_type = this.termList[0].term;

            }
            try {
                await this.getReportType();
                await this.getIsNewDIm();
                await this.gradequeryOrgInfo();
                this.switchGetData();

            } catch {
                console.error('异步调用失败:', err);
            }


        },
        async getIsNewDIm() {
            let data = {
                termKey: this.termValue,
                schoolId: this.$route.query.schoolId,
                examType: this.reportValue
            }
            let resData = await this.$Api.DataScreen.getIsNewDIm(data);
            this.table_type = resData.data;

        },
        // switchGetData() {

        //     if (this.reportValue == 1) {
        //         this.gather();
        //         //前后侧
        //     } else if (this.reportValue == 2) {
        //         this.gather();
        //         //月测   优化
        //     } else if (this.reportValue == 4) {
        //         this.monthParticipation();
        //         //周测
        //     } else if (this.reportValue == 5) {
        //         this.weekParticipation();
        //     }
        // },
        switchGetData() {
            switch (this.reportValue) {
                case 1:
                case 2:
                case 101:
                case 102:
                case 103:
                    return this.gather();
                case 4:
                    return this.monthParticipation();
                case 5:
                    return this.weekParticipation();
                default:
                    console.warn(`未处理的 reportValue: ${this.reportValue}`);
                    this.isEmpty = false;
            }
        },
        //获取班级
        async gradequeryOrgInfo() {
            this.gradeValue = '';
            this.gradeId = '';
            this.gradeList = [];
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: this.termValue,
                userId: sessionStorage.getItem('teacherId'),
            }
            let resData = await this.$Api.DataScreen.queryTeacherClassSelect(data);
            if (resData.data.length == 0) {
                this.isEmpty = false;
                return;
            }

            this.isEmpty = true;
            this.gradeList = resData.data
                .filter(item => Array.isArray(item.sonOrgList))
                .flatMap(item =>
                    item.sonOrgList.map(item_son => ({
                        ...item_son,
                        className: item.name
                    }))
                );
            // resData.data.forEach(item => {
            //     item.sonOrgList.forEach(item_son => {
            //         item_son.className = item.name;
            //     })
            // });
            // this.gradeList = resData.data.reduce((accumulator, currentObj) => {
            //     return [...accumulator, ...currentObj.sonOrgList];
            // }, []);


            if (this.$route.query.source == 'upload') {
                this.className = this.$route.query.gradeValue || '';
                this.gradeValue = this.$route.query.gradeValue || '';
                this.gradeId = this.$route.query.gradeId || '';
            } else {
                this.className = this.gradeList[0]?.className || '';
                this.gradeValue = this.gradeList[0]?.name || '';
                this.gradeId = this.gradeList[0]?.bindId || '';
            }
            // console.log(' this.gradeList', this.gradeList);

            this.getClassStuAllTypeScoreList()
        },
        //整体数据
        async getparticipation() {
            let data;
            let resData;
            if (this.reportValue == 4) {
                data = {
                    schoolId: this.$route.query.schoolId,
                    termKey: this.termValue,
                    testId: this.monthVal,
                    examType: 4,
                    classId: this.gradeId,
                }
                resData = this.table_type == 1 ? await this.$Api.Report.overallSituation(data) : await this.$Api.Report.getoverallSituation_month(data);
                if (resData) {
                    this.userNum = resData.data.classTakeNum;
                    this.gradeRate = resData.data.gradeJoinRate;
                    this.wrongGrip = resData.data.goodP;
                    this.gradeWrongGrip = resData.data.gradeGoodPRateClass;
                    this.wrongSitPosition = resData.data.bad;
                    this.gradeWrongSitPosition = resData.data.gradeBad;
                    this.excellentRate = resData.data.goodRate;
                    this.gradeExcellentRate = resData.data.gradeGoodRate;
                } else {
                    this.userNum = 0;
                    this.gradeRate = 0;
                    this.wrongGrip = 0;
                    this.gradeWrongGrip = 0;
                    this.wrongSitPosition = 0;
                    this.gradeWrongSitPosition = 0;
                    this.excellentRate = 0;
                    this.gradeExcellentRate = 0;
                }




            } else {
                data = {
                    classId: this.gradeId,
                    termKey: this.termValue,
                    examType: this.reportValue,
                }
                resData = await this.$Api.Report.getparticipation(data);
                if (resData) {
                    this.userNum = resData.data.userNum;
                    this.gradeRate = resData.data.gradeRate;
                    this.wrongGrip = resData.data.wrongGrip;
                    this.gradeWrongGrip = resData.data.gradeWrongGrip;
                    this.wrongSitPosition = resData.data.wrongSitPosition;
                    this.gradeWrongSitPosition = resData.data.gradeWrongSitPosition;
                    this.excellentRate = resData.data.excellentRate;
                    this.gradeExcellentRate = resData.data.gradeExcellentRate;
                } else {
                    this.userNum = 0;
                    this.gradeRate = 0;
                    this.wrongGrip = 0;
                    this.gradeWrongGrip = 0;
                    this.wrongSitPosition = 0;
                    this.gradeWrongSitPosition = 0;
                    this.excellentRate = 0;
                    this.gradeExcellentRate = 0;
                }
            }
            if (this.userNum == 0) {
                this.isEmpty = false;
                return false;
            } else {
                this.isEmpty = true;
                return true;
            }

        },
        //书写习惯-坐姿
        async getsitPosition() {
            let data = {
                classId: this.gradeId,
                termKey: this.termValue,
                examType: this.reportValue,
            }
            let resData = await this.$Api.Report.getsitPosition(data);


            if (resData && resData.data != null) {
                this.sitting_Data = [this.writeNum(resData.data.thisTerm), this.writeNum(resData.data.lastTerm)];
                this.sitting_Data[0].date = '本学期';
                this.sitting_Data[1].date = '上学期';
                // 本学期坐姿错误数
                let mistake_count = this.sitting_Data[0].wrongNum;
                // 本学期坐姿正确数
                let correct_count = this.sitting_Data[0].correctNum;
                this.sitting_Data_mistake = mistake_count;
                // 占全校百分比
                this.sitting_wrongNumSchoolRatio = resData.data.wrongNumSchoolRatio;
                this.sitting_position_graph(mistake_count, correct_count)
            }

        },
        //书写习惯-握姿
        async getholdAPenPosture() {
            let data = {
                classId: this.gradeId,
                termKey: this.termValue,
                examType: this.reportValue,
            }
            let resData = await this.$Api.Report.getholdAPenPosture(data);

            if (resData && resData.data != null) {
                this.hold_Data = [this.writeNum(resData.data.thisTerm), this.writeNum(resData.data.lastTerm)];
                this.hold_Data[0].date = '本学期';
                this.hold_Data[1].date = '上学期';
                // 本学期坐姿错误数
                let mistake_count = this.hold_Data[0].wrongNum;
                // 本学期坐姿正确数
                let correct_count = this.hold_Data[0].correctNum;
                this.hold_Data_mistake = mistake_count;
                // 占全校百分比
                this.hold_wrongNumSchoolRatio = resData.data.wrongNumSchoolRatio;
                this.hold_position_graph(mistake_count, correct_count)
            }
        },
        //本班单项成绩等级占比
        async getstudentLvRatioCompare() {
            let data = {
                classId: this.gradeId,
                termKey: this.termValue,
                examType: this.reportValue
            }
            let resData = await this.$Api.Report.getstudentLvRatioCompare(data);
            this.$refs.score_Proportion_tea_old.receiveData(resData, this.gradeValue, this.userNum, this.table_type);
        },
        //本班单项成绩等级占比
        async getstudentLvRatioCompareV2() {
            let data = {
                classId: this.gradeId,
                termKey: this.termValue,
                examType: this.reportValue,
                examId: this.monthVal
            }
            let resData = await this.$Api.Report.getstudentLvRatioCompareV2(data);
            this.$refs.score_Proportion_tea_new.receiveData(resData, this.gradeValue, this.userNum, this.table_type);
        },
        judge_type_icon(value1, value2) {
            if (value1 > value2) {
                return 'imgUrl1'
            } else if (value1 < value2) {
                return 'imgUrl2'
            } else {
                return 'imgUrl3'
            }

        },
        //一级维度成绩
        async getoneDScoreCompare() {
            let data = {
                classId: this.gradeId,
                termKey: this.termValue,
                examType: this.reportValue
            }
            let resData = await this.$Api.Report.getoneDScoreCompare(data);
            this.$refs.score_Proportion_tea_old.receiveData_dimension(resData);
        },
        //一级维度成绩-班级
        async getoneDScoreCompareV2() {
            let data = {
                classId: this.gradeId,
                termKey: this.termValue,
                examType: this.reportValue,
                examId: this.monthVal
            }
            let resData = await this.$Api.Report.getoneDScoreCompareV2(data);
            this.$refs.score_Proportion_tea_new.receiveData_dimension(resData, this.gradeValue, this.table_type);
        },
        //判断水平
        judgeLevel(value) {
            if (this.table_type == 1) {
                if (value >= 90) {
                    return '优秀+'
                } else if (value >= 80 && value < 90) {
                    return '优秀-'
                } else if (value >= 60 && value < 80) {
                    return '良好'
                } else {
                    return '待提升'
                }
            } else {
                if (value >= 85) {
                    return '优秀';
                } else if (value >= 70 && value < 85) {
                    return '良好';
                } else if (value >= 60 && value < 70) {
                    return '合格';
                } else {
                    return '待提升';
                }
            }

        },
        average(value1, value2) {
            return value1 > value2 ? '高于' : value1 < value2 ? '低于' : '等于'
        },
        //“优秀+”作品样例 分页
        async getlevel4WorkPage() {
            this.workList = [];
            let data;
            let resData;
            //月测
            if (this.reportValue == 4) {
                if (this.table_type == 1) {
                    data = {
                        schoolId: this.$route.query.schoolId,
                        termKey: this.termValue,
                        testId: this.monthVal,
                        examType: 4,
                        classId: this.gradeId,
                    }
                    resData = await this.$Api.Report.getWorksSch(data);
                    resData.data.records.map(item => {
                        this.workList.push(item.filePath)
                    });
                    this.workurl = this.workList[0];
                } else {
                    data = {
                        schoolId: this.$route.query.schoolId,
                        termKey: this.termValue,
                        testId: this.monthVal,
                        examType: 4,
                        classId: this.gradeId,
                    }
                    resData = await this.$Api.Report.getWorksSchV2(data);
                    resData.data.records.map(item => {
                        this.workList.push(item.filePath)
                    });
                    this.workurl = this.workList[0];
                }

            } else {
                //前后测
                data = {
                    classId: this.gradeId,
                    termKey: this.termValue,
                    size: this.limit,
                    current: this.pageSize,
                    examType: this.reportValue,
                }
                resData = await this.$Api.Report.getlevel4WorkPage(data);
                if (resData.data?.records.length < this.limit) {
                    this.current = 1;
                } else {
                    this.current += 1;
                }
                resData.data.records.map(item => {
                    this.workList.push(item.fileUrl)
                })
            }


        },
        stochastic() {
            const randomIndex = Math.floor(Math.random() * this.workList.length);
            this.workurl = this.workList[randomIndex];
        },
        //本班优秀 学生名单 旧
        async geteliteStudent() {
            this.workList = [];
            let that = this;
            let data = {
                classId: this.gradeId,
                termKey: this.termValue,
                examType: this.reportValue,
            }
            let resData = await this.$Api.Report.geteliteStudent(data);
            this.student_list_Data = resData.data.map(item => {
                return {
                    ...item,
                    className: that.className,
                    gradeName: that.gradeValue,
                    newlevel: that.student_list_Data_level_old[item.level]
                }
            })
        },
        //本班优秀 学生名单 新
        async geteliteStudentV2() {
            this.workList = [];
            let that = this;
            let data = {
                classId: this.gradeId,
                termKey: this.termValue,
                examType: this.reportValue,
            }
            let resData = await this.$Api.Report.geteliteStudentV2(data);
            this.student_list_Data = resData.data.map(item => {
                return {
                    ...item,
                    className: that.className,
                    gradeName: that.gradeValue,
                    newlevel: that.student_list_Data_level[item.level]
                }
            })
        },
        getexportExcel() {
            let Rtype = {
                1: '前测报告-教师',
                2: '后测报告-教师',
                101: '测评卷Ⅰ报告-教师',
                102: '测评卷Ⅱ报告-教师',
                103: '测评卷Ⅲ报告-教师',
                4: '月测报告-教师',
                5: '周测报告-教师',
            }
            let data = {
                classId: this.gradeId,
                termKey: this.termValue,
                examType: this.reportValue,
                schoolId: this.$route.query.schoolId
            }
            if (this.reportValue == 4) {
                data.testId = this.monthVal
            } else if (this.reportValue == 5) {
                data.testId = this.weekValue
            }
            if (this.table_type == 1) {
                this.$Api.Report.getexportExcel(data)
                    .then(res => {
                        const link = document.createElement('a')
                        const blob = new Blob([res], {
                            type: 'application/x-msdownload'
                        });
                        const fileName = Rtype[this.reportValue];
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.download = fileName + '.xlsx';
                        link.click();
                        document.body.removeChild(link);
                    })
                    .catch(err => {
                        console.log('导出失败:', err)
                    })
            } else {
                this.$Api.Report.getexportExcelV2(data)
                    .then(res => {
                        const link = document.createElement('a')
                        const blob = new Blob([res], {
                            type: 'application/x-msdownload'
                        });
                        const fileName = this.reportType == 4 ? '月测报告-教师' : '前后测报告-教师';
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.download = fileName + '.xlsx';
                        link.click();
                        document.body.removeChild(link);
                    })
                    .catch(err => {
                        console.log('导出失败:', err)
                    })
            }

        },
        getexportExcel_week() {
            let Rtype = {
                1: '前测报告-教师',
                2: '后测报告-教师',
                101: '测评卷Ⅰ报告-教师',
                102: '测评卷Ⅱ报告-教师',
                103: '测评卷Ⅲ报告-教师',
                4: '月测报告-教师',
                5: '周测报告-教师',
            }
            let data = {
                classId: this.gradeId,
                termKey: this.termValue,
                examType: this.reportValue,
                schoolId: this.$route.query.schoolId
            }
            if (this.reportValue == 4) {
                data.testId = this.monthVal
            } else if (this.reportValue == 5) {
                data.testId = this.weekValue
            }
            this.$Api.Report.getexportExcelV2(data)
                .then(res => {
                    const link = document.createElement('a')
                    const blob = new Blob([res], {
                        type: 'application/x-msdownload'
                    });
                    const fileName = Rtype[this.reportValue];
                    link.style.display = 'none';
                    link.href = URL.createObjectURL(blob);
                    document.body.appendChild(link);
                    link.download = fileName + '.xlsx';
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(err => {
                    console.log('导出失败:', err)
                })


        },
        //切换学期
        async termChange(val) {
            const index = this.termList.findIndex(item => item.key == val);
            this.currentTerm = this.termList[index].termName;
            this.semester_name = this.termList[index].termName;
            this.term_type = this.termList[index].term;

            this.monthVal = '';
            this.weekValue = '';
            this.gradeValue = '';
            this.reportValue = '';
            this.reportList = [];
            try {
                await this.getIsNewDIm();
                // await this.gradequeryOrgInfo();
                await this.getReportType();
                this.switchGetData();
            } catch {
                console.error('异步调用失败:', err);
            }
        },
        //切换班级
        async gradeChange(item) {

            this.gradeValue = item.label;
            this.gradeId = item.value;
            const index = this.gradeList.findIndex(i => i.name == item.label);
            this.className = this.gradeList[index].className;
            try {
                // await this.getIsNewDIm();
                // await this.gradequeryOrgInfo();
                await this.switchGetData();
                this.getClassStuAllTypeScoreList()
            } catch {
                console.error('异步调用失败:', err);
            }
        },
        // 前后测报告请求集合
        async gather() {

            // 整体数据
            if (!await this.getparticipation()) return;
            // // 书写习惯-坐姿


            this.getsitPosition();
            // // 书写结果判断握笔姿势
            this.getholdAPenPosture();
            if (this.table_type == 1) {
                // 本班单项成绩等级占比 旧版
                this.getstudentLvRatioCompare();
                // 一级维度成绩 旧版
                this.getoneDScoreCompare();
                //本班优秀名单
                this.geteliteStudent();
            } else {
                // 本班单项成绩等级占比 新版
                this.getstudentLvRatioCompareV2();
                // 一级维度成绩 新版
                this.getoneDScoreCompareV2();
                //本班优秀名单
                this.geteliteStudentV2();


            }
            // //进步较大的学生
            this.getrankClassStuDiff();
            // //作品样例
            this.getlevel4WorkPage();
        },
        //书写习惯-坐姿
        sitting_position_graph(value1, value2) {
            this.$echarts.init(document.getElementById("sitting_position_graph")).dispose();
            let myChart = this.$echarts.init(
                document.getElementById("sitting_position_graph")
            );
            myChart.setOption({
                color: ['#48c5ec', '#72d07e'],
                title: {
                    text: '坐姿',
                    top: '4%',
                    left: 'center',
                    textStyle: {
                        fontSize: this.graphicRatio(14),
                    },
                },
                legend: {
                    top: '12%',
                    left: 'center',
                    itemWidth: this.graphicRatio(22),
                    itemHeight: this.graphicRatio(14),
                    textStyle: {
                        fontSize: this.graphicRatio(12),
                    }
                },
                series: [
                    {
                        name: '书写习惯-坐姿',
                        type: 'pie',
                        radius: '50%',
                        label: {
                            formatter: "{b} {c} 人",
                            fontSize: this.graphicRatio(14),
                        },
                        data: [
                            { value: value2, name: '正确人数' },
                            { value: value1, name: '错误人数' },
                        ],
                        itemStyle: {
                            borderWidth: this.graphicRatio(5),
                            borderColor: '#fff',
                        }
                    }
                ]
            });
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
        //书写习惯-握笔姿势
        hold_position_graph(value1, value2) {
            this.$echarts.init(document.getElementById("hold_position_graph")).dispose();
            let myChart = this.$echarts.init(
                document.getElementById("hold_position_graph")
            );
            myChart.setOption({
                color: ['#dc91e0', '#fc918e'],
                title: {
                    text: '握笔姿势',
                    top: '4%',
                    left: 'center',
                    textStyle: {
                        fontSize: this.graphicRatio(14),
                    },
                },
                legend: {
                    top: '12%',
                    left: 'center',
                    itemWidth: this.graphicRatio(22),
                    itemHeight: this.graphicRatio(14),
                    textStyle: {
                        fontSize: this.graphicRatio(12),
                    }
                },
                series: [
                    {
                        name: '书写习惯-握笔姿势',
                        type: 'pie',
                        radius: '50%',
                        label: {
                            formatter: "{b} {c} 人",
                            fontSize: this.graphicRatio(14),
                        },
                        data: [
                            { value: value2, name: '正确人数' },
                            { value: value1, name: '错误人数' },
                        ],
                        itemStyle: {
                            borderWidth: this.graphicRatio(5),
                            borderColor: '#fff',
                        }
                    }
                ]
            });
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
        //与上学期对比
        Term_comparison_graph(value1) {
            this.$echarts.init(document.getElementById("Term_comparison_graph")).dispose();
            let myChart = this.$echarts.init(
                document.getElementById("Term_comparison_graph")
            );
            myChart.setOption({
                grid: {
                    top: '30%',
                    left: '4%',
                    right: '4%',
                    bottom: '2%',
                    containLabel: true,
                },
                tooltip: {
                    trigger: 'axis',
                    confine: true,
                    padding: this.graphicRatio(5),
                    textStyle: {
                        fontSize: this.graphicRatio(14),
                    },
                },
                legend: {
                    show: true,
                    icon: 'rect',
                    orient: 'horizontal',
                    top: '6%',
                    y: 'center',
                    itemWidth: this.graphicRatio(22),
                    itemHeight: this.graphicRatio(14),
                    textStyle: {
                        fontSize: this.graphicRatio(12),
                    },
                    data: [
                        { name: '本学期', icon: 'circle' },
                    ],
                },
                xAxis: [
                    {
                        splitLine: {
                            show: false,
                        },
                        axisTick: {
                            show: true,
                            lineStyle: {
                                color: '#dddddd'
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#dddddd'
                            },
                        },
                        axisLabel: {
                            show: true,
                            fontSize: this.graphicRatio(14),
                            color: '#555555',
                            // interval: 'auto',
                        },
                        type: 'category',
                        data: ["优秀+", "优秀-", "良好", "待提升"],
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                    {
                        axisLabel: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                    },
                ],
                series: [
                    {
                        name: '本学期',
                        type: 'pictorialBar',
                        barGap: '0%',
                        barWidth: this.graphicRatio(60),
                        symbol: "path://M12.000,-0.000 C12.000,-0.000 16.074,60.121 22.731,60.121 C26.173,60.121 -3.234,60.121 0.511,60.121 C7.072,60.121 12.000,-0.000 12.000,-0.000 Z",
                        // barGap:10,
                        color: '#247FFF',
                        label: {
                            show: true,
                            position: 'top',
                            fontSize: this.graphicRatio(14),
                            formatter: function (params) {
                                return params.value + '%'
                            },
                        },
                        data: value1,
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(
                                0,
                                1,
                                0,
                                0,
                                [
                                    {
                                        offset: 0,
                                        color: 'rgba(49, 232, 255, 0.68)', // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.4,
                                        color: 'rgba(149, 231, 212, 1)', // 100% 处的颜色
                                    },
                                ],
                                false
                            ),
                        },
                        emphasis: {
                            disabled: true,
                            focus: 'none',
                        },
                    },
                ],
            });
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
        //一级维度成绩
        dimension_graph(value, maxValue) {
            this.$echarts.init(document.getElementById("dimension_graph")).dispose();
            let myChart = this.$echarts.init(
                document.getElementById("dimension_graph")
            );
            let splitColor = "#fff";
            myChart.setOption({
                tooltip: {
                    show: true,
                    showContent: true,
                    textStyle: {
                        fontSize: this.graphicRatio(12),
                    },
                },
                radar: {
                    center: ["50%", "50%"], // 外圆的位置
                    radius: "60%",
                    axisName: {
                        color: "#033333",
                        fontSize: this.graphicRatio(14),
                        fontWeight: 400,
                        fontFamily: "PingFangSC-Regular,PingFang SC",
                        fontStyle: "normal",
                    },
                    indicator: [{ name: '章法占格', max: maxValue },
                    { name: '结构组合', max: maxValue },
                    { name: '笔画形态', max: maxValue },
                    { name: '作品完整度', max: maxValue },],
                    splitArea: {
                        // 坐标轴在 grid 区域中的分隔区域，默认不显示。
                        show: true,
                        areaStyle: {
                            // 分隔区域的样式设置。
                            color: ["RGBA(228, 229, 235, 1)"], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                        },
                    },
                    axisLine: {
                        // 指向外圈文本的分隔线样式
                        lineStyle: {
                            color: splitColor,
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: "solid",
                            color: splitColor, // 分隔线颜色
                            width: this.graphicRatio(1), // 分隔线线宽
                        },
                    },
                },
                series: [{
                    type: "radar",
                    symbolSize: this.graphicRatio(10),
                    symbol: "none",
                    itemStyle: {
                        borderColor: "FFD900",
                        // color: "#fff",
                        borderWidth: this.graphicRatio(0.2),
                    },
                    lineStyle: {
                        width: this.graphicRatio(1),
                        color: '#9b95f7',
                    },
                    data: [{
                        name: '前侧',
                        value: value,
                        label: {
                            fontSize: this.graphicRatio(14),
                            formatter: '{value}%'
                        },
                        areaStyle: {
                            color: "rgba(155, 149, 247, 1)"
                        },
                    },],
                },
                ],

            });
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
        // 切换报告类型
        async reportChange(val) {
            try {
                await this.getIsNewDIm();
                await this.gradequeryOrgInfo();
                await this.switchGetData();
            } catch {
                console.error('异步调用失败:', err);
            }
        },
        // 获取月测类型
        async monthParticipation() {
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: this.termValue,
                examType: 4,
                classId: this.gradeId,
            }
            let resData = await this.$Api.Report.monthParticipation(data);
            this.monthList = resData.data;
            if (resData.data.length > 0) {
                if (this.$route.query.source == 'upload' && this.$route.query.monthValue != 'undefined' && this.$route.query.monthName != 'undefined') {
                    this.monthVal = Number(this.$route.query.monthValue);
                    this.monthName = this.$route.query.monthName;
                } else {
                    this.monthVal = resData.data[0].id;
                    this.monthName = resData.data[0].name;
                }
                // this.monthVal = resData.data[0].id;
                // this.monthName = resData.data[0].name;
                this.month_report();
                this.isEmpty = true;
            } else {
                this.isEmpty = false
            }

        },
        // 获取周测类型
        async weekParticipation() {
            this.weekList = [];
            this.weekValue = '';
            let that = this;
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: this.termValue,
                examType: 5,
                classId: this.gradeId,
            }
            let resData = await this.$Api.Report.getparticipationWeek(data);
            // this.weekList = resData.data;
            if (resData.data.length != 0) {
                this.weekList = resData.data;
                if (this.$route.query.source == 'upload' && this.$route.query.weekValue != 'undefined' && this.$route.query.weekName != 'undefined') {
                    this.weekValue = Number(this.$route.query.weekValue);
                    // console.log('this.weekValue',this.weekValue);

                    this.weekName = this.$route.query.weekName;
                    //   console.log('this.weekName',this.weekName);

                } else {
                    this.weekList = resData.data;
                    this.weekValue = this.weekList[0].id;
                    this.weekName = this.weekList[0].name;
                }

                this.isEmpty = false;
                // this.$refs.weekTest_tea.Request_collection(this.termValue, this.weekValue, this.weekName, this.gradeId, this.gradeValue, this.isEmpty);
                this.getClassStuAllTypeScoreList()
                this.$refs.weekTest_tea.Request_collection(this.termValue, this.weekValue, this.weekName, this.gradeId, this.gradeValue, this.isEmpty, this.currentTerm, this.reportValue, this.term_type);
            } else {
                this.isEmpty = true;
                // this.$refs.weekTest_tea.Request_collection(this.termValue, this.weekValue, this.weekName, this.gradeId, this.gradeValue, this.isEmpty);
                this.$refs.weekTest_tea.Request_collection(this.termValue, this.weekValue, this.weekName, this.gradeId, this.gradeValue, this.isEmpty, this.currentTerm, this.reportValue, this.term_type);
            }
        },
        // 切换月测名称
        monthTypeChange(val) {
            this.monthVal = val;
            this.monthName = this.monthList.find(item => {
                return item.id == val;
            }).name;
            this.month_report()
        },
        // 切换周测名称
        weekValTypeChange(val) {
            // console.log(val);
            this.weekVal = val;
            this.weekName = this.weekList.find(item => {
                return item.id == val;
            }).name;
            // this.weekParticipation();
            // this.month_report()
            this.$refs.weekTest_tea.Request_collection(this.termValue, this.weekValue, this.weekName, this.gradeId, this.gradeValue, this.isEmpty, this.currentTerm, this.reportValue, this.term_type);
            this.getClassStuAllTypeScoreList()
        },
        // 本班单项成绩等级占比
        async monthLevelStuNumGroup() {
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: this.termValue,
                testId: this.monthVal,
                examType: 4,
                classId: this.gradeId,
            }
            let resData = this.table_type == 1 ? await this.$Api.Report.monthLevelStuNumGroup(data) : await this.$Api.Report.getlevelStuNumGroupV2_month(data);
            resData.data.map(item => {
                item.classPropRate = item.classProp + '%';
                item.gradePropRate = item.gradeProp + '%';
                if (this.table_type == 1) {
                    item.integrationLevel = item.integrationLevel == 1 ? '待提升' : item.integrationLevel == 2 ? '良好' : item.integrationLevel == 3 ? '优秀' : '优秀+'
                } else {
                    item.integrationLevel = item.integrationLevel == 1 ? '待提升' : item.integrationLevel == 2 ? '合格' : item.integrationLevel == 3 ? '良好' : '优秀'
                }

            })
            this.month_Data = resData.data.reverse();
            // 计算结论1  本班学生综合成绩来看,平均成绩xx等级的学生居多, 优秀率为xx%, xx年级优秀率
            let maxClassProp = 0;
            let maxClassProp2 = 0;
            let maxClassLevel = null;
            let gradeProp = 0;
            let arr = []
            this.month_Data.map((item, index) => {
                let obj = {
                    value: Number(item.classProp),
                    name: item.integrationLevel
                }
                arr.push(obj);
                if (Number(item.classProp) > 0) {
                    if (Number(item.classProp) > maxClassProp) {
                        maxClassProp = Number(item.classProp);
                        maxClassLevel = item.integrationLevel;
                        // gradeCompare = item.classProp > item.gradeProp ? '高于' : item.classProp < item.gradeProp ? '低于' : '等于'
                    } else if (Number(item.classProp) == maxClassProp) {
                        maxClassLevel += item.integrationLevel
                    }
                };
                if (this.table_type == 1) {
                    if (item.integrationLevel == '优秀' || item.integrationLevel == '优秀+') {
                        maxClassProp2 += Number(item.classProp);
                        gradeProp += item.gradeProp;
                    }

                } else {
                    if (item.integrationLevel == '良好' || item.integrationLevel == '优秀') {
                        maxClassProp2 += Number(item.classProp);
                        gradeProp += item.gradeProp;
                    }
                }

            })
            this.maxClassProp = maxClassProp2;
            this.maxgradeProp = gradeProp;
            this.maxClassLevel = maxClassLevel;
            this.gradeCompare = maxClassProp2 > gradeProp ? '高于' : maxClassProp2 < gradeProp ? '低于' : '等于';
            this.month_class_proportion_graph(arr);
        },
        // 本班学生测评等级列表
        async monthClassStuScoreList() {
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: this.termValue,
                testId: this.monthVal,
                examType: 4,
                classId: this.gradeId,
            }
            let resData = this.table_type == 1 ? await this.$Api.Report.monthClassStuScoreList(data) : await this.$Api.Report.getclassStuScoreListV2_month(data);
            this.month_student_list_Data = resData.data
        },
        // 本班单项成绩等级占比饼图
        month_class_proportion_graph(data) {
            this.$echarts.init(document.getElementById("month_class_proportion")).dispose();
            let myChart = this.$echarts.init(
                document.getElementById("month_class_proportion")
            );
            myChart.setOption({
                // color: ['#48c5ec', '#72d07e'],
                legend: {
                    top: '8%',
                    left: 'center',
                    itemWidth: this.graphicRatio(22),
                    itemHeight: this.graphicRatio(14),
                    textStyle: {
                        fontSize: this.graphicRatio(12),
                    }
                },
                series: [
                    {
                        // name: '书写习惯-坐姿',
                        type: 'pie',
                        radius: '50%',
                        label: {
                            formatter: "{b} {c} %",
                            fontSize: this.graphicRatio(14),
                        },
                        data,
                        itemStyle: {
                            borderWidth: this.graphicRatio(5),
                            borderColor: '#fff',
                        }
                    }
                ]
            });
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
        // AI测评维度成绩
        async monthAI() {
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: this.termValue,
                testId: this.monthVal,
                examType: 4,
                classId: this.gradeId,
            }
            let resData = this.table_type == 1 ? await this.$Api.Report.monthAI(data) : await this.$Api.Report.getaiScoreV2_month(data);
            if (this.table_type == 1) {


                if (resData.data.class.length == 0 || !resData.data.class[0]) {
                    this.$refs.singleSubjectAvg_tea_month_old.receiveData(this.AI_Data, [0, 0, 0, 0], 100)
                } else {
                    let obj = {
                        name: this.gradeValue,
                        consistenceScore: resData.data.class[0].consistenceScore,
                        neatScore: resData.data.class[0].neatScore,
                        likelyScore: resData.data.class[0].likelyScore,
                        completeScore: resData.data.class[0].completeScore,
                        consistenceScore_type: this.judge_type_icon(resData.data.class[0].consistenceScore, resData.data.grade[0].consistenceScore),
                        neatScore_type: this.judge_type_icon(resData.data.class[0].neatScore, resData.data.grade[0].neatScore),
                        likelyScore_type: this.judge_type_icon(resData.data.class[0].likelyScore, resData.data.grade[0].likelyScore),
                        completeScore_type: this.judge_type_icon(resData.data.class[0].completeScore, resData.data.grade[0].completeScore),
                        consistenceScore_average: this.average(resData.data.class[0].consistenceScore, resData.data.grade[0].consistenceScore),
                        neatScore_average: this.average(resData.data.class[0].neatScore, resData.data.grade[0].neatScore),
                        likelyScore_average: this.average(resData.data.class[0].likelyScore, resData.data.grade[0].likelyScore),
                        completeScore_average: this.average(resData.data.class[0].completeScore, resData.data.grade[0].completeScore),
                        consistenceScore_level: this.judgeLevel(resData.data.class[0].consistenceScore),
                        neatScore_level: this.judgeLevel(resData.data.class[0].neatScore),
                        likelyScore_level: this.judgeLevel(resData.data.class[0].likelyScore),
                        completeScore_level: this.judgeLevel(resData.data.class[0].completeScore),
                    }
                    let obj2 = {
                        name: '年级均值',
                        consistenceScore: resData.data.grade[0].consistenceScore,
                        neatScore: resData.data.grade[0].neatScore,
                        likelyScore: resData.data.grade[0].likelyScore,
                        completeScore: resData.data.grade[0].completeScore,
                        consistenceScore_type: '',
                        neatScore_type: '',
                        likelyScore_type: '',
                        completeScore_type: ''
                    };
                    this.AI_Data = [obj, obj2];
                    let arr = [resData.data.class[0].consistenceScore, resData.data.class[0].neatScore, resData.data.class[0].likelyScore, resData.data.class[0].completeScore]
                    this.$refs.singleSubjectAvg_tea_month_old.receiveData(this.AI_Data, arr, 100)
                }
            } else {

                if (resData.data.class.length == 0 || !resData.data.class[0]) {
                    this.$refs.singleSubjectAvg_tea_month_new.receiveData(this.AI_Data, [0, 0, 0, 0, 0, 0, 0, 0], 100);
                } else {
                    let data1 = resData.data.class[0];
                    data1.name = this.gradeValue;
                    data1.centerPos_type = this.judge_type_icon(resData.data.class[0].centerPos, resData.data.grade[0].centerPos);
                    data1.gridSize_type = this.judge_type_icon(resData.data.class[0].gridSize, resData.data.grade[0].gridSize);
                    data1.glyphGrav_type = this.judge_type_icon(resData.data.class[0].glyphGrav, resData.data.grade[0].glyphGrav);
                    data1.comboRel_type = this.judge_type_icon(resData.data.class[0].comboRel, resData.data.grade[0].comboRel);
                    data1.rewindRel_type = this.judge_type_icon(resData.data.class[0].rewindRel, resData.data.grade[0].rewindRel);
                    data1.multiDist_type = this.judge_type_icon(resData.data.class[0].multiDist, resData.data.grade[0].multiDist);
                    data1.strokeRel_type = this.judge_type_icon(resData.data.class[0].strokeRel, resData.data.grade[0].strokeRel);
                    data1.integrity_type = this.judge_type_icon(resData.data.class[0].integrity, resData.data.grade[0].integrity);

                    data1.centerPos_average = this.average(resData.data.class[0].centerPos, resData.data.grade[0].centerPos);
                    data1.gridSize_average = this.average(resData.data.class[0].gridSize, resData.data.grade[0].gridSize);
                    data1.glyphGrav_average = this.average(resData.data.class[0].glyphGrav, resData.data.grade[0].glyphGrav);
                    data1.comboRel_average = this.average(resData.data.class[0].comboRel, resData.data.grade[0].comboRel);
                    data1.rewindRel_average = this.average(resData.data.class[0].rewindRel, resData.data.grade[0].rewindRel);
                    data1.multiDist_average = this.average(resData.data.class[0].multiDist, resData.data.grade[0].multiDist);
                    data1.strokeRel_average = this.average(resData.data.class[0].strokeRel, resData.data.grade[0].strokeRel);
                    data1.integrity_average = this.average(resData.data.class[0].integrity, resData.data.grade[0].integrity);
                    data1.centerPos_average = this.average(resData.data.class[0].centerPos, resData.data.grade[0].centerPos);

                    data1.centerPos_level = this.judgeLevel(resData.data.class[0].centerPos);
                    data1.gridSize_level = this.judgeLevel(resData.data.class[0].gridSize);
                    data1.glyphGrav_level = this.judgeLevel(resData.data.class[0].glyphGrav);
                    data1.comboRel_level = this.judgeLevel(resData.data.class[0].comboRel);
                    data1.rewindRel_level = this.judgeLevel(resData.data.class[0].rewindRel);
                    data1.multiDist_level = this.judgeLevel(resData.data.class[0].multiDist);
                    data1.strokeRel_level = this.judgeLevel(resData.data.class[0].strokeRel);
                    data1.integrity_level = this.judgeLevel(resData.data.class[0].integrity);
                    let data2 = resData.data.grade[0];
                    data2.name = '年级均值';
                    data2.centerPos_type = '';
                    data2.gridSize_type = '';
                    data2.glyphGrav_type = '';
                    data2.comboRel_type = '';
                    data2.rewindRel_type = '';
                    data2.multiDist_type = '';
                    data2.strokeRel_type = '';
                    data2.integrity_type = '';
                    this.AI_Data = [data1, data2];
                    let arr = [
                        resData.data.class[0].centerPos,
                        resData.data.class[0].gridSize,
                        resData.data.class[0].glyphGrav,
                        resData.data.class[0].comboRel,
                        resData.data.class[0].rewindRel,
                        resData.data.class[0].multiDist,
                        resData.data.class[0].strokeRel,
                        resData.data.class[0].integrity
                    ]
                    this.$refs.singleSubjectAvg_tea_month_new.receiveData(this.AI_Data, arr, 100)
                };

            }
        },
        // 月测报告请求集合
        month_report() {
            // 整体情况
            this.getparticipation();
            // 本班单项成绩等级占比
            this.monthLevelStuNumGroup();
            // // 本班学生测评等级列表
            this.monthClassStuScoreList();
            // // AI测评维度成绩
            this.monthAI();
            // // 优秀+作品
            this.getlevel4WorkPage();
            if (this.table_type == 2) {
                //本班单项成绩等级占比
                this.getstudentLvRatioCompareTV2_month();
            }
        },
        hide_school() {
            let type = this.schoolIdArr.includes(this.$route.query.schoolId);
            if (this.schoolIdArr.includes(this.$route.query.schoolId) && this.termValue == '20232') {
                // type = true;
                this.isEmpty = true;
            } else {
                this.isEmpty = false;
            }
            // return type;
        },
        async getstudentLvRatioCompareTV2_month() {
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: this.termValue,
                testId: this.monthVal,
                examType: 4,
                classId: this.gradeId,
            };
            let res = await this.$Api.Report.getstudentLvRatioCompareTV2_month(data);
            this.$refs.singleSubjectAvg_tea_month_new.gradesPercentage(res);
        },
        showImagePreview(value) {
            this.isPreviewing = true;
            this.disableScroll();
            this.$refs[value][0].showViewer = true;
        },
        disableScroll() {
            document.body.style.overflow = 'hidden';
        },
        enableScroll() {
            document.body.style.overflow = '';
        },
        async getrankClassStuDiff() {
            let data = {
                termKey: this.termValue,
                examType: this.reportValue,
                classId: this.gradeId,
            };
            let res = await this.$Api.Report.getrankClassStuDiff(data);
            this.profilePictureData = res.data ?? [];
        },
        // 重置数据
        resetData() {
            //前后测测数据
            //测评人数
            this.userNum = 0;
            //本年级参与率
            this.gradeRate = 0;
            // 握姿错误
            this.wrongGrip = 0;
            //本年级
            this.gradeWrongGrip = 0;
            //坐姿错误
            this.wrongSitPosition = 0;
            //本年级
            this.gradeWrongSitPosition = 0;
            //书写习惯-坐姿
            this.sitting_Data = [];
            // 结论1评语
            //坐姿错误人数
            this.sitting_Data_mistake = 0;
            //占全校
            this.sitting_wrongNumSchoolRatio = 0;
            //书写习惯-握笔姿势
            this.hold_Data = [];
            //坐姿错误人数
            this.hold_Data_mistake = 0;
            //占全校
            this.hold_wrongNumSchoolRatio = 0;
            //本班单项成绩等级占比
            //新版数据
            this.new_data = null;
            //旧版数据
            this.old_data = null;
            //优秀作品
            this.workList = [];
            //本班优秀学生名单
            this.student_list_Data = [];
            //进步较大的学生
            this.profilePictureData = [];
            if (this.table_type == 1) {
                this.$refs.score_Proportion_tea_old.receiveData(false, this.gradeValue, this.userNum, this.table_type);
            } else {
                this.$refs.score_Proportion_tea_new.receiveData(false, this.gradeValue, this.userNum, this.table_type);
            }

        },
        writeNum(value) {

            if (value) {
                return {
                    correctNum: value[0].correctNum,
                    ratio: value[0].ratio + '%',
                    wrongNum: value[0].wrongNum,
                }
            } else {
                return {
                    correctNum: '/',
                    ratio: '/',
                    wrongNum: '/',
                }
            }
        },
        // 获取四象限数据
        async getClassStuAllTypeScoreList() {
            let testId = '';
            if (this.reportValue == 4) {
                testId = this.monthVal
            } else if (this.reportValue == 5) {
                testId = this.weekValue
            }
            let data = {
                termKey: this.termValue,
                classId: this.gradeId,
                examType: this.reportValue,
                testId
            }
            let resData = await this.$Api.Report.getClassStuAllTypeScoreList(data);
            // console.log('四象限数据', resData);
            if (resData.data.dataList.length > 0) {
                this.fourQuadrantsStuList = resData.data.dataList;
                this.currentGrade = resData.data.grade
            }
        },
        // 选择四象限图
        selectItem(item, index) {
            this.dialogTitle = item.examName
            this.dialogVisible = true;
            setTimeout(() => {
                this.initChart(item)
            })
        },
        initChart(chartData) {
            this.$echarts.init(document.getElementById(`historyChart`)).dispose();
            let myChart = this.$echarts.init(document.getElementById(`historyChart`));
            let data = []
            // x轴数据 = 居中+占格+组合+多画的平均分
            // y轴数据 = 重心+笔画+收放的平均分
            chartData.stuList.map(item => {
                let xData = ((Number(item.centerPos) + Number(item.gridSize) + Number(item.comboRel) + Number(item.multiDist)) / 4).toFixed(2);
                let yData = ((Number(item.glyphGrav) + Number(item.strokeRel) + Number(item.rewindRel)) / 3).toFixed(2);
                let obj = {
                    name: item.stuName,
                    value: [xData, yData]
                }
                data.push(obj)
            })
            myChart.setOption({
                // title: {
                //     text: chartData.examName,
                //     left: 'center'
                // },
                tooltip: {
                    show: true,
                    trigger: 'item',
                    formatter: (params) => `( 努力:${params.value[0]},天赋:${params.value[1]})`,
                    position: 'right'
                },
                xAxis: {
                    type: 'value',
                    min: 40,
                    max: 100,
                    axisLine: {
                        onZero: false,
                        // show: false
                    },
                    // axisTick: { show: false }, // 隐藏刻度线
                    // axisLabel: { show: false },
                    splitLine: {
                        show: false   // ❗ 不显示网格线
                    },
                    interval: 10,
                },
                yAxis: {
                    type: 'value',
                    min: 40,
                    max: 90,
                    axisLine: {
                        onZero: false,
                        // show: false
                    },
                    // axisTick: { show: false }, // 隐藏刻度线
                    // axisLabel: { show: false },
                    splitLine: {
                        show: false   // ❗ 不显示网格线
                    },
                    interval: 10,
                },
                series: [
                    {
                        type: 'scatter',
                        label: {
                            show: true,
                            position: 'top',
                            formatter: params => params.data.name
                        },
                        data,
                        itemStyle: {
                            color: '#5470C6'
                        },
                        markLine: {
                            symbol: ['none', 'arrow'],
                            silent: true,
                            data: [
                                {
                                    xAxis: this.averageNum[this.currentGrade][1], // 纵轴线
                                    label: {
                                        show: true,
                                        position: 'start',
                                        formatter: '大众型'
                                    }
                                },
                                {
                                    yAxis: this.averageNum[this.currentGrade][0], // 横轴线
                                    label: {
                                        show: true,
                                        position: 'start',
                                        formatter: '自然成长'
                                    }
                                },
                                {
                                    xAxis: this.averageNum[this.currentGrade][1], // 纵轴线
                                    label: {
                                        show: true,
                                        position: 'end',
                                        formatter: '天赋型'
                                    }
                                },
                                {
                                    yAxis: this.averageNum[this.currentGrade][0], // 横轴线
                                    label: {
                                        show: true,
                                        position: 'end',
                                        formatter: '笃行不倦'
                                    }
                                }
                            ],
                            lineStyle: {
                                type: 'solid',
                                color: '#aaa'
                            }
                        }
                    }
                ],
                dataZoom: [
                    {
                        type: 'inside',
                        startValue: 40,
                        endValue: 100,
                    }
                ]
            })
        },
        async getReportType() {
            await this.gradequeryOrgInfo();
            let data = {
                termKey: this.termValue,
                schoolId: this.$route.query.schoolId,
                classId: this.gradeId,
            }
            let resData = await this.$Api.Report.getReportType(data);
            console.log('获取已测评的报告类型:', resData);
            if (resData.data.length > 0) {
                this.reportList = resData.data;
                this.reportValue = resData.data[0].type;
            }
        }
    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        //api请求
        this.getTermList();
        this.schoolName = this.$route.query.schoolName;
    }
}
</script>
<style lang='less' scoped>
@import url("./less/frontBackaAppraisal_tea.less");
</style>